import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdjustedGrade, AdjustedGradeDto, Inspection, InspectionElement } from '../../types/inspection';
import { Asset } from '../../types/asset';

export interface InspectionState {
    inspection: Inspection | undefined;
    loading: boolean;
    error: boolean;
    photoFolders: InspectionElement[];
    images: Asset[];
    loadingImages: boolean;
    errorImages: boolean;
    viewImages: Asset[];
    showGenerateItemsDialog: boolean;
    adjustedGrades: AdjustedGradeDto | undefined;
    errorAdjustedGrades: boolean;
    loadingAdjustedGrades: boolean;
    savingGrades: boolean;
    errorSavingGrades: boolean;
}

export const initialState: InspectionState = {
    inspection: undefined,
    loading: true,
    error: false,
    photoFolders: [],
    images: [],
    loadingImages: false,
    errorImages: false,
    viewImages: [],
    showGenerateItemsDialog: false,
    adjustedGrades: undefined,
    errorAdjustedGrades: false,
    loadingAdjustedGrades: false,
    savingGrades: false,
    errorSavingGrades: false
};

export const inspectionSlice = createSlice({
    name: 'inspection',
    initialState,
    reducers: {
        setInspection: (state, action: PayloadAction<Inspection | undefined>) => {
            state.inspection = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
        setPhotoFolders: (state, action: PayloadAction<InspectionElement[]>) => {
            state.photoFolders = action.payload;
        },
        setImages: (state, action: PayloadAction<Asset[]>) => {
            state.images = action.payload;
        },
        setLoadingImages: (state, action: PayloadAction<boolean>) => {
            state.loadingImages = action.payload;
        },
        setErrorImages: (state, action: PayloadAction<boolean>) => {
            state.errorImages = action.payload;
        },
        updateImages: (state, action: PayloadAction<Asset[]>) => {
            state.images = state.images.map((image) => {
                if (!image.objectURL) {
                    const match = action.payload.find((item) => image.asset_id === item.asset_id);

                    if (match) {
                        return match;
                    }
                }

                return image;
            });
        },
        setViewImages: (state, action: PayloadAction<Asset[]>) => {
            state.viewImages = action.payload;
        },
        setShowGeneratedItemsDialog: (state, action: PayloadAction<boolean>) => {
            state.showGenerateItemsDialog = action.payload;
        },
        setAdjustedGrades: (state, action: PayloadAction<AdjustedGradeDto | undefined>) => {
            state.adjustedGrades = action.payload;
        },
        setLoadingAdjustedGrades: (state, action: PayloadAction<boolean>) => {
            state.loadingAdjustedGrades = action.payload;
        },
        setErrorAdjustedGrades: (state, action: PayloadAction<boolean>) => {
            state.errorAdjustedGrades = action.payload;
        },
        setSavingGrades: (state, action: PayloadAction<boolean>) => {
            state.savingGrades = action.payload;
        },
        setErrorSavingGrades: (state, action: PayloadAction<boolean>) => {
            state.errorSavingGrades = action.payload;
        },
    },
});

export const { 
    setInspection,
    setLoading,
    setError,
    setPhotoFolders,
    setImages,
    setLoadingImages,
    setErrorImages,
    updateImages,
    setViewImages,
    setShowGeneratedItemsDialog,
    setAdjustedGrades,
    setLoadingAdjustedGrades,
    setErrorAdjustedGrades,
    setSavingGrades,
    setErrorSavingGrades,
 } = inspectionSlice.actions;

export default inspectionSlice.reducer;
